"use strict";
const glnField = document.querySelector('#gln');
const digitListOrderCheckboxes = Array.from(document.querySelectorAll("input[name='orderCheckDigitList[order]']"));
if (digitListOrderCheckboxes.length > 0) {
    glnField.addEventListener('blur', () => {
        if (glnField.value !== '') {
            digitListOrderCheckboxes.forEach((orderCheckbox) => {
                orderCheckbox.addEventListener('change', (changeEvent) => {
                    const el = changeEvent.target;
                    const gTinListNeeded = document.querySelector('#info_gtin_list_needed');
                    const fieldId = el.id;
                    const fieldLabel = document.querySelector(`${fieldId}`);
                    if (el.checked || (el.checked && el.id === fieldLabel.id)) {
                        (gTinListNeeded.classList.contains('hidden')) ? gTinListNeeded.classList.remove('hidden') : '';
                        const documentBlocker = document.createElement('div');
                        documentBlocker.classList.add('modal__blocker');
                        if (documentBlocker) {
                            document.querySelector('body').appendChild(documentBlocker);
                        }
                    }
                });
            });
        }
    });
}
